export default __webpack_public_path__ + "static/media/cp_geo_iq.50d96638.svg";